var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('video',{ref:"video",attrs:{"width":_vm.videoWidth,"height":_vm.videoHeight},on:{"ended":function($event){return _vm.slideshow.nextSlide()}}},[_c('source',{attrs:{"src":_vm.src,"type":"video/mp4"}}),_c('p',[_vm._v("Your browser does not support HTML 5 video")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }